// src/components/Apm/Country/Countries.js

import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { useMediaQuery, useTheme } from '@mui/material';

import { useGetCountriesQuery } from '../../../redux/features/countryApi';
import { columnsCountries } from '../Tables/Columns/columnsCountries';
import TableSimple from '../Tables/TableSimple';

const Countries = () => {
  const { t } = useTranslation();

  const theme = useTheme();

  const smMediaDown = useMediaQuery(theme.breakpoints.down('sm'));

  const { data: countries = [], isLoading, isFetching, refetch } = useGetCountriesQuery();

  const updatedColumns = useMemo(() => {
    const columns = columnsCountries();

    if (!smMediaDown) {
      return columns;
    }

    return columns.filter((column) => column.id === 'label' || column.id === 'value');
  }, [smMediaDown]);

  const handleRefresh = useCallback(async () => {
    console.log('Countries refresh started');

    const result = await refetch();

    console.log('Countries refresh result:', result);

    if (result.error) {
      throw result.error;
    }

    toast.success(() => t('toast.country_list_updated'));
  }, [refetch, t]);

  return (
    <TableSimple
      resource="countries"
      columns={updatedColumns}
      data={countries}
      isFetching={isFetching || isLoading}
      onRefresh={handleRefresh}
    />
  );
};

export default Countries;
